<template>
  <div class="health-large-card-container">
    <ArticleCardLarge
      v-if="article"
      v-bind="useArticleProps(article)"
      :loading-views="getLoadingViews(article.id)"
      :img-lazy="false"
      :show-category-icon="false"
      :is-authenticated-in-wordpress="isAuthenticatedInWordpress"
      @click-on-restore-button="updateViewsCount(article.id)"
      @favorite-delete="(favorite) => onFavoriteDelete(favorite, article)"
      @favorite-create-folder-and-add="
        (nameFolder) => onFavoriteCreateFolderAndAdd(nameFolder, article)
      "
      @favorite-create-folder-and-transfer="
        (nameFolder, favorite) =>
          onFavoriteCreateFolderAndTransfer(nameFolder, favorite, firstArticle)
      "
      @favorite-transfer-to-folder="
        (favorite, folder) => onFavoriteTransferToFolder(favorite, folder, article)
      "
      @favorite-add-to-folder="(folder) => onFavoriteAddToFolder(folder, article)"
      @favorite-deferred="onFavoriteDeferred"
      @click-on-article-card="onClickArticleCardLarge"
      @show-context-menu="onContextMenu(article.id)"
    />
  </div>
</template>

<script lang="ts">
  import type { PropOptions } from 'vue';
  import { ArticleCardLarge } from '~/components/lh-ui/ArticleCard/index';

  import { useIndexStore } from '~/store';
  import { useArticlesStore } from '~/store/articles';
  import { getFullUrl } from '~/utils';
  import { useArticleProps } from '~/composables/useArticleProps';
  import { useFavorite } from '@/composables/useFavoriteMethods';
  import { useUpdatingViewsCount } from '@/composables/useUpdatingViewsCount';
  import { trimWpDomainInPlace } from '~/utils/trimWpDomain';

  export default defineNuxtComponent({
    name: 'HealthLargeCardContainer',

    components: {
      ArticleCardLarge,
    },

    props: {
      elem: {
        type: Object,
        required: true,
      } as PropOptions<TContent>,
    },

    async setup(props) {
      const {
        onFavoriteDelete,
        onFavoriteCreateFolderAndAdd,
        onFavoriteCreateFolderAndTransfer,
        onFavoriteTransferToFolder,
        onFavoriteAddToFolder,
        onFavoriteDeferred,
      } = useFavorite();
      const { loadingViewsIds, updateViewsCount, getLoadingViews } = useUpdatingViewsCount();

      const app = useNuxtApp();
      const elemProp = props.elem;
      const article = ref(null);
      const { data, error } = await useAsyncData(() =>
        app.$healthApi.fetchSinglePost(elemProp.attributes.post),
      );

      if (error.value) {
        console.error('Error in HealthLargeCardContainer.vue:', error.value);
      }

      trimWpDomainInPlace(data.value.data, ['item.url', 'item.categories.url']);
      article.value = data.value.data.item;

      return {
        onFavoriteDelete,
        onFavoriteCreateFolderAndAdd,
        onFavoriteCreateFolderAndTransfer,
        onFavoriteTransferToFolder,
        onFavoriteAddToFolder,
        onFavoriteDeferred,
        loadingViewsIds,
        updateViewsCount,
        getLoadingViews,
        articlesStore: useArticlesStore(),
        article,
        indexStore: useIndexStore(),
      };
    },

    computed: {
      isAuthenticatedInWordpress(): boolean {
        return this.indexStore.isAuthenticatedInWordpress;
      },
    },

    mounted() {
      if (this.article) {
        this.articlesStore.fetchAndSetFavorites({
          post_ids: String(this.article.id),
          per_page: 1,
        });
      }
    },

    methods: {
      useArticleProps,
      onClickArticleCardLarge() {
        this.$sendYandexMetrika({
          level1: 'Выбор материала_Виджет большая карточка',
          level4: getFullUrl(this.article?.url || '') || '',
        });
      },
      onContextMenu() {
        this.$emit('show-context-menu');
      },
    },
  });
</script>
